<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        CreateSchedule(
          v-on:createDone="getSchedule"
          v-on:createReady="manualCreateReady = true"
          v-on:emitProgress="emitProgress"
          :medRecordId="medRecordId"
          :manualInputMedRecordId="manualInputMedRecordId"
          :bedId="bedId"
          :gender="gender"
          v-if="stage === 'Start' && starttype === 'Manual'")
        OperatingRoomScheduleList(
          v-if="stage === 'Start' && starttype === 'OperatingRoomHIS'"
          v-on:setSchedule="getSchedule"
          v-on:setPatientSchedule="getPatientSchedule"
        )
        ScheduleList(
          v-if="stage === 'Start' && starttype === 'HIS'"
          v-on:setSchedule="getSchedule"
          :filterOutZeroAmountMed="filterOutZeroAmountMed"
        )
        ComboMedListAndPatient(
          v-if="stage === 'ComboMedListAndPatient'"
          :filterOutZeroAmountMed="filterOutZeroAmountMed"
        )
        MultiFlow(
          v-if="stage === 'startFlow'"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          v-on:setAllConfirmData="getAllConfirmData"
        )
        Loader(
          v-if="stage === 'finish'"
        )

    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel" :clickable="currentApp.cancel")
      //- action-button(title="昨日排程" slot="button-3" @click.native="scheduleType = 'yesterday'" v-if="stage === 'Start' && starttype === 'HIS'")
      //- action-button(title="今日排程" slot="button-3" @click.native="scheduleType = 'today'" v-if="stage === 'Start' && starttype === 'HIS'")
      //- action-button(title="手動排程" slot="button-3" @click.native="chastartType('Manual')")
      //- action-button(title="HIS排程" slot="button-3" @click.native="changeStartType('HIS')")
      //- action-button(title="手動取藥" slot="button-3" @click.native="$router.push({ name: 'fetchDrug', params: { stage: 'selectDrug' } })" v-if="stage === 'ComboMedListAndPatient'")
      //- action-button(title="套藥取藥" slot="button-3" @click.native="$router.push({ name: 'fetchDrugCombo' })")
      action-button(title="類別取藥" slot="button-4" @click.native="$router.push({ name: 'fetchDrugGroup' })" v-if="stage === 'ComboMedListAndPatient'")
      //- action-button(title="上ㄧ步驟" slot="button-8" v-if="stage !== 'startFlow'" @click.native="$children[1].previousProgress" :clickable="manualCreateProgress > 0")
      //- action-button(title="下ㄧ步驟" slot="button-8" v-if="stage !== 'startFlow'" @click.native="$children[1].nextProgress" :clickable="manualCreateProgress < 2")
      
      //- action-button(title="更新排程" slot="button-8" @click.native="fireRefetch += 1" v-if="stage === 'ScheduleList'")
      action-button(title="開始取藥" slot="button-9" @click.native="startFlow" v-if="stage === 'ComboMedListAndPatient'" :clickable="DrugsForFetchList.length > 0")
      //- action-button(title="下ㄧ步驟" slot="button-9" @click.native="$children[1].startAction" v-if="stage === 'Start'")
      action-button(title="手動排程" slot="button-9" @click.native="manualSchedule" v-if="starttype === 'OperatingRoomHIS'" :clickable="manualEnable===true")
      

</template>

<script>
import AppBase from './ComponentBase/AppBase';
import progressBar from './flowComp/ProgressBar';
import ScheduleList from './flowComp/ScheduleList';
import ComboMedListAndPatient from './flowComp/ComboMedListAndPatient';
import MultiFlow from './ScheduleFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';
import Loader from './common/Loader';
import CreateSchedule from './flowComp/CreateSchedule';
import OperatingRoomScheduleList from './flowComp/OperatingRoomScheduleList';

export default {
  name: 'Schedule',
  extends: AppBase,
  components: {
    progressBar,
    ScheduleList,
    ComboMedListAndPatient,
    MultiFlow,
    BottomButtons,
    Loader,
    CreateSchedule,
    OperatingRoomScheduleList,
  },
  data() {
    return {
      fireRefetch: 0,
      starttype: '',
      manualCreateReady: false,
      manualCreateProgress: 0,
      filterOutZeroAmountMed: false,
      scheduleType: 'today',
      manualEnable: true,
      medRecordId: '',
      manualInputMedRecordId: true,
      bedId: undefined,
      gender: undefined,
    };
  },
  created() {
    this.stage = 'Start';
    this.startTypeSwitch();
    // if (this.$route.params.stage) {
    //   // this.stage = this.$route.params.stage;
    // } else {
    //   // this.stage = 'ScheduleList';
    // }
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', 'manual');
  },
  computed: {
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    DrugsForFetchList() {
      return this.$store.state.drug.DrugsForFetchList;
    },
  },
  methods: {
    startTypeSwitch() {
      //console.log('generalSetting:',this.$store.state.generalSetting);
      const systemSetting = this.$store.state.generalSetting.mode;
      switch (systemSetting) {
        case 'nursing':
          this.starttype = 'HIS';
          this.filterOutZeroAmountMed = true;
          break;
        case 'surgery':
          //this.starttype = 'Manual';
          this.starttype = 'OperatingRoomHIS';
          this.filterOutZeroAmountMed = false;
          break;
        default:
          //this.starttype = 'Manual';
          this.starttype = 'OperatingRoomHIS';
          this.filterOutZeroAmountMed = false;
          break;
      }
    },
    setupProgress() {
      const p = [];
      p.push({ en: 'manual', zh: '設定排程' });
      p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // if (this.starttype === 'Manual') {
      //   // p.push({ en: 'selectMed', zh: '選擇使用藥物' });
      //   // p.push({ en: 'selectBed', zh: '選擇病床' });
      //   // p.push({ en: 'inputMedRecordNo', zh: '輸入病歷號' });
      //   p.push({ en: 'manual', zh: '手動輸入' });
      //   p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // }
      // if (this.starttype === 'HIS') {
      //   p.push({ en: 'selectPatient', zh: '選擇病人' });
      //   p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const prog = [];
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionWrapProgress() {
      const prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    getSchedule() {
      if(this.starttype == 'OperatingRoomHIS'){
        this.starttype = 'Manual';
      }
      else{
        this.stage = 'ComboMedListAndPatient';
      }
    },
    async startFlow() {
      this.$store.dispatch('printQR', this.$store.state.drug.DrugsForFetchList);
      // for (let i = 0; i < this.$store.state.drug.DrugsForFetchList.length; i += 1) {
      //   const fetchItem = this.$store.state.drug.DrugsForFetchList[i];
      //   // if (fetchItem.med.restrained_class > 0) {
      //   this.$store.dispatch('printQR', fetchItem);
      //   // }
      // }
      await this.$store.dispatch('fromFirstDrug');
      this.stage = 'startFlow';
    },
    changeStartType(val) {
      this.starttype = val;
      this.$store.commit('SET_PROGRESS', this.setupProgress());
    },
    async getAllConfirmData() {
      this.stage = 'finish';
      // refetch data
      this.$store.dispatch('resetAll');
      await this.$store.dispatch('getDrugInDevices');
      //20190516 add
      if(this.starttype === 'Manual') {
        this.starttype = 'OperatingRoomHIS';
        this.manualEnable = true;
        this.medRecordId = '';
        this.manualInputMedRecordId = true; 
      }
      this.stage = 'Start';
      this.$store.commit('RESET_SCHEDULE');
      this.$store.commit('SET_CURRENT_STEP', 'manual');
    },
    emitProgress(val) {
      this.manualCreateProgress = val;
    },
    manualSchedule() {
      this.starttype = 'Manual';  
    },
    getPatientSchedule(data) {
      this.manualEnable = data.manualEnable;
      this.medRecordId = data.medRecordId;
      this.bedId = data.bedId;
      this.gender = data.gender;
      if(this.medRecordId === ''){
       this.manualInputMedRecordId = true; 
      }
      else{
        this.manualInputMedRecordId = false;   
      }
    }
  },
  watch: {
    stage(val) {
      if (val === 'Start') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// Schedule.vue?0cd1b01d